// src/pages/Conflo.jsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Icons } from "../assets/icons/icons";
import confloletras from "../assets/img/logoConfloLetra.png";
import conflo from "../assets/img/Conflo-Logo.jpg";

const Conflo = () => {
  // Datos de las estadísticas
  const stats = [
    { icon: Icons.Briefcase, number: "18+", label: "Proyectos" },
    { icon: Icons.Calendart, number: "7+", label: "Años" },
  ];

  return (
    <>
      <Header />
      <main className="pt-24">
        <section className="bg-gray-700">
          <div className="container mx-auto px-4 py-16 lg:py-24">
            <div className="flex flex-col lg:flex-row items-center lg:items-start space-y-8 lg:space-y-0 lg:space-x-12">
              {/* Columna Izquierda: Texto e Información */}
              <div className="lg:w-1/2 text-white p-6">
                {/* Logo e Identidad */}
                <div className="flex items-center mb-6">
                  <img
                    src={confloletras}
                    alt="Logo CONFLO"
                    className="w-16 h-16 rounded-md mr-4"
                  />
                  <div>
                    <h1 className="text-4xl font-extrabold tracking-tight">
                      CONFLO
                    </h1>
                    <p className="text-xl font-light text-gray-300">
                      Construcción y Fluidos
                    </p>
                  </div>
                </div>

                {/* Descripción */}
                <p className="text-lg leading-relaxed mb-10 text-gray-200">
                  Texto sobre la empresa Conflo.
                </p>

                <div className="flex flex-wrap justify-start gap-8 mt-12">
                  {stats.map((stat, index) => (
                    <div key={index} className="text-center">
                      {/* Los íconos de estadística usan el color de acento */}
                      <stat.icon className="w-6 h-6 mx-auto mb-2 text-[#e74c3c]" />{" "}
                      <div className="text-3xl font-bold">{stat.number}</div>
                      <div className="text-sm text-gray-300">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Columna Derecha: Imagen */}
              <div className="lg:w-1/2 w-full">
                <div className="relative overflow-hidden rounded-lg shadow-2xl">
                  {/* Usando la variable 'imagenRobotica' para la imagen grande */}
                  <img
                    src={conflo}
                    alt="Robots en construcción industrial"
                    className="w-full h-auto object-cover transform hover:scale-105 transition duration-500"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section>...</section> */}
      </main>

      {/* 3. Footer */}
      <Footer />
    </>
  );
};

export default Conflo;
